// ENV-006B2: application-owned origins.
//
// URLs that point back into the running OutreachOS application must use the
// origin the browser is actually served from. A staging or preview deployment
// must never generate, persist, display, or email a URL for a different
// application environment, so there is deliberately no production default here.

function trimText(value) {
  return typeof value === 'string' ? value.trim() : '';
}

export function normalizeAppOrigin(value) {
  const candidate = trimText(value);
  if (!candidate) return '';

  let parsed;
  try {
    parsed = new URL(candidate);
  } catch {
    return '';
  }

  if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') return '';
  if (parsed.username || parsed.password) return '';

  return parsed.origin;
}

export function getAppOrigin(
  currentLocation = typeof window !== 'undefined' ? window.location : null
) {
  return normalizeAppOrigin(currentLocation?.origin)
    || normalizeAppOrigin(currentLocation?.href);
}

export function buildAppUrl(
  path,
  currentLocation = typeof window !== 'undefined' ? window.location : null
) {
  const origin = getAppOrigin(currentLocation);
  if (!origin) return '';

  const suffix = trimText(path);

  let resolved;
  try {
    resolved = new URL(suffix.startsWith('/') ? suffix : `/${suffix}`, `${origin}/`);
  } catch {
    return '';
  }

  // WHATWG URL parsing treats protocol-relative and backslash-prefixed forms
  // ("//other.example", "/\other.example") as authority-changing, so resolution
  // alone cannot keep a caller-supplied path on this application's origin.
  return resolved.origin === origin ? resolved.toString() : '';
}
